<script>
  import { Link } from "svelte-routing";
  // import { copyToClipboard } from "../helper";
  import resume from "../resume.js";
  import { onMount } from "svelte";
</script>

<main class="bg-gray-100 dark:bg-gray-700 pt-32 pb-20 overflow-auto flex">
  <div class="m-auto">
    <div class="mb-5">
      <Link
        to="/"
        class="px-4 py-2 inline-block leading-4 border-green-400 border bg-green-200 hover:bg-green-300 rounded-none mr-3 text-gray-700 font-mono"
      >
        <p class="text-gray-700 font-bold font-mono">
          <i class="fas fa-arrow-left mr-3" />Go Back
        </p></Link
      >
      <button
        on:click={() => window.print()}
        class="px-4 py-1 font-bold font-mono text-gray-700 border-indigo-400 border bg-indigo-200 hover:bg-indigo-300 rounded-none"
        ><i class="fas fa-print mr-3" />Print</button
      >

      <a
        href='https://drive.google.com/file/d/15Z6j2XjWlcKy6UodD713FRg-q-vaavcT/view?usp=sharing'
        class="px-4 py-1 font-bold font-mono text-gray-700 border-indigo-400 border bg-indigo-200 hover:bg-indigo-300 rounded-none"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fas fa-download mr-3"></i>Download
      </a>
    </div> 
      <img src='/images/cv july 2024.png' alt='cv'>
  </div>
</main>
